import React, { useState } from "react";
import SplashScreen from "./components/SplashScreen";
import Dashboard from "./components/Dashboard";

export default function App() {
  const [user, setUser] = useState(null);

  // if user exists, skip to dashboard; otherwise show splash
  return user ? (
    <Dashboard user={user} />
  ) : (
    <SplashScreen onLoginSuccess={setUser} />
  );
}
